import { NAV_PATH } from '@/router/constants';

export const InquiryTab = {
	cate: '',
	title: '무엇이든 물어보세요',
	subTab: [
		{ title: '서비스 문의', link: NAV_PATH.INQUIRY.SERVICE, cate: '서비스 문의' },
		{ title: '제휴 문의', link: NAV_PATH.INQUIRY.PARTNERSHIP, cate: '제휴 문의' }
	]
};

export const ConsultingTab = {
	cate: 'ss',
	title: '무엇이든 물어보세요',
	subTab: [
		{ title: '서비스 문의', link: NAV_PATH.INQUIRY.SERVICE, cate: '서비스 문의' },
		{ title: '제휴 문의', link: NAV_PATH.INQUIRY.PARTNERSHIP, cate: '제휴 문의' }
	]
};
